import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"text-center mx-auto",attrs:{"max-width":"400","width":"100%","flat":""}},[_c('v-card-item',[_c(VCardTitle,{class:_vm.titleClass},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VCardSubtitle,{class:_vm.subtitleClass},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])],1),_c(VCardText,[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c(VCardText,[_c(VForm,{ref:"form"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }